import { render, staticRenderFns } from "./ContactsListSidebar.vue?vue&type=template&id=7b957bbe&scoped=true&"
import script from "./ContactsListSidebar.vue?vue&type=script&lang=js&"
export * from "./ContactsListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ContactsListSidebar.vue?vue&type=style&index=0&id=7b957bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b957bbe",
  null
  
)

export default component.exports